import { filter, get } from 'lodash';

import {
    EMPLOYER_REP_ROLES,
    EMPLOYER_REP_STATUSES,
} from '../../../constants/EmployerRep';
import GreenIcon from '../../../assets/image/commonIcons/green-check-icon.svg';
import RedIcon from '../../../assets/image/commonIcons/red-stop.svg';
import YellowIcon from '../../../assets/image/commonIcons/yellow-watches.svg';

export const TALENYA_COMPANY_NAME = 'TALENYA';

export const EMPLOYER_REP_LIST_COLUMNS = [
    {
        id: 'name', label: 'EMPLOYER_REP_MANAGE_TABLE_COLUMN_NAME_LABEL', workBreak: 'break-all', useTooltip: true,
    },
    {
        id: 'email', label: 'EMPLOYER_REP_MANAGE_TABLE_COLUMN_EMAIL_LABEL', workBreak: 'break-all', useTooltip: true,
    },
    {
        id: 'email2', label: 'EMPLOYER_REP_MANAGE_TABLE_COLUMN_EMAIL2_LABEL', workBreak: 'break-all', useTooltip: true,
    },
    {
        id: 'linkedin', label: 'EMPLOYER_REP_MANAGE_TABLE_COLUMN_LINKEDIN_LABEL', workBreak: 'break-all',
    },
    {
        id: 'phones', label: 'EMPLOYER_REP_MANAGE_TABLE_COLUMN_PHONE_LABEL', workBreak: 'break-all', format: (val) => get(val, '0.value', ''),
    },
    { id: 'title', label: 'EMPLOYER_REP_MANAGE_TABLE_COLUMN_TITLE_LABEL', workBreak: 'break-all' },
    { id: 'departmentName', label: 'EMPLOYER_REP_MANAGE_TABLE_COLUMN_COMPANY_LABEL', workBreak: 'break-all' },
    { id: 'role', label: 'EMPLOYER_REP_MANAGE_TABLE_COLUMN_ROLE_LABEL' },
    { id: 'type', label: 'EMPLOYER_REP_MANAGE_TABLE_COLUMN_TYPE_LABEL' },
    { id: 'status', label: 'EMPLOYER_REP_MANAGE_TABLE_COLUMN_STATUS_LABEL', format: (val) => get(val, 'current', '') },
    { id: 'actions', label: 'EMPLOYER_REP_MANAGE_TABLE_COLUMN_ACTIONS_LABEL' },
];

export const getEmployerRepListColumns = ({ isDepartmentsEnabled }) => (isDepartmentsEnabled
    ? EMPLOYER_REP_LIST_COLUMNS
    : filter(EMPLOYER_REP_LIST_COLUMNS, ({ id }) => id !== 'departmentName'));

export const TABLE_COLUMN_WIDTH = {
    TITLE: 200,
};

export const EMPLOYER_REP_ROLE_OPTIONS = [{
    value: EMPLOYER_REP_ROLES.HR,
    label: 'HR',
    description: 'HR_DESCRIPTION',
}, {
    value: EMPLOYER_REP_ROLES.NON_HR,
    label: 'NON_HR',
    description: 'NON_HR_DESCRIPTION',
}, {
    value: EMPLOYER_REP_ROLES.HIRING_MANAGER,
    label: 'HIRING_MANAGER_DESCRIPTION',
    description: 'HIRING_MANAGER_DESCRIPTION',
}, {
    value: EMPLOYER_REP_ROLES.SALES,
    label: 'SALES_DESCRIPTION',
    description: 'SALES_DESCRIPTION',
}];

export const EMPLOYER_REP_TYPE_OPTIONS = [{
    value: EMPLOYER_REP_ROLES.USER,
    label: 'REGULAR_ACCESS',
    description: 'CAN_ACCESS_EVERYTHING_BUT_CANNOT_CREATE_USERS',
}, {
    value: EMPLOYER_REP_ROLES.ADMIN,
    label: 'FULL_ACCESS',
    description: 'CAN_ACCESS_EVERYTHING_AND_CREATE_USERS',
}];

export const TRANSLATIONS_BY_STATUS = {
    [EMPLOYER_REP_STATUSES.ACTIVE]: 'EMPLOYER_REP_ACTIVE',
    [EMPLOYER_REP_STATUSES.INACTIVE]: 'EMPLOYER_REP_INACTIVE',
    [EMPLOYER_REP_STATUSES.SELF_SERVICE]: 'EMPLOYER_REP_SELF_SERVICE',
    [EMPLOYER_REP_STATUSES.INVITED]: 'EMPLOYER_REP_INVITED',
    [EMPLOYER_REP_STATUSES.PENDING]: 'EMPLOYER_REP_PENDING',
};

export const getIconClassName = (status) => {
    if (status === EMPLOYER_REP_STATUSES.ACTIVE) {
        return GreenIcon;
    } if (status === EMPLOYER_REP_STATUSES.INACTIVE) {
        return RedIcon;
    } if ([EMPLOYER_REP_STATUSES.INVITED, EMPLOYER_REP_STATUSES.PENDING, EMPLOYER_REP_STATUSES.SELF_SERVICE].indexOf(status) > -1) {
        return YellowIcon;
    }

    return '';
};

export const checkIfEmailExists = (existingEmails, newEmail) => (existingEmails || []).findIndex((email) => (email || '').toLowerCase() === (newEmail || '').toLowerCase()) !== -1;
